export default function BottomShadow() {
	return (
		<div
			aria-hidden="true"
			className="absolute bottom-0 left-0 right-0 h-px pointer-events-none shadow-[0_-6px_12px_-4px_rgba(0,0,0,0.12)] transition-opacity duration-300"
		/>
	)
}
